import React, { ComponentProps } from "react";
import { spacing } from "../../stitches.config";
import { Tag as StyledTag } from "./__styles__/Tag";
import { Icon, IconNames } from "./Icons/LucideIcons";
import { Body } from "./Typography";

const IconColorMap = {
  default: "contentInfo",
  neutral: "contentSecondary",
  warning: "contentAttentionAccessible",
  critical: "contentCritical",
  neutralInverted: "contentSecondaryInverted",
} as const;

export type StyleVariant =
  | "default"
  | "neutral"
  | "warning"
  | "critical"
  | "neutralInverted";

export type TagProps = Omit<
  ComponentProps<typeof StyledTag>,
  "css" | "styleVariant" | "onClick"
> & {
  styleVariant: StyleVariant;
  leftIconName?: IconNames;
  loading?: boolean;
  onClose?: () => void;
  disabled?: boolean;
  "data-testid"?: string;
};

export const Tag = ({
  leftIconName,
  loading,
  styleVariant,
  onClose,
  disabled,
  ...props
}: TagProps) => {
  return (
    <StyledTag styleVariant={styleVariant} data-testid={props["data-testid"]}>
      {leftIconName && (
        <Icon
          iconName={leftIconName}
          color={IconColorMap[styleVariant]}
          size={12}
        />
      )}
      <Body
        type="emphasis"
        size="small"
        color={
          styleVariant === "neutralInverted" ?
            "contentPrimaryInverted"
          : "contentPrimary"
        }
      >
        {props.children}
      </Body>
      {onClose && (
        <button
          onClick={onClose}
          disabled={disabled}
          aria-label="Remove"
          style={{ paddingTop: spacing["2xs"].value }}
        >
          <Icon
            iconName={"x"}
            color={
              styleVariant === "neutralInverted" ?
                "contentSecondaryInverted"
              : "contentSecondary"
            }
            size={12}
            data-testid={"tag-close-icon"}
          />
        </button>
      )}
    </StyledTag>
  );
};
